import { observable } from 'mobx'
import { AxiosRequestConfig } from 'axios'

interface DealWithHttp<P, SR> {
  Execute(Params?: P, config?: AxiosRequestConfig): Promise<SR>
  Cancel(): void
}

const MobXHttp = <P, SR, FR>(DWHttp: DealWithHttp<P, SR>, OnSuccess?: (Result: SR, CResult: SR | null, Params?: P) => SR) => {
  const Store = observable<{
    /**是否正在执行Http请求*/
    Loading: boolean
    /**Http请求成功结果*/
    SuccessResult: SR | null
    /**Http请求失败结果*/
    FailedResult: FR | null
  }>({ Loading: false, SuccessResult: null, FailedResult: null })
  /**
   * 执行Http操作
   */
  const Execute = async (Params?: P, config?: AxiosRequestConfig): Promise<SR> => {
    try {
      Store.Loading = true
      const Result = await DWHttp.Execute(Params, config)
      if (OnSuccess) {
        Store.SuccessResult = OnSuccess(Result, Store.SuccessResult, Params)
      } else {
        Store.SuccessResult = Result
      }
      Store.Loading = false
      return Result
    } catch (e) {
      Store.FailedResult = e
      Store.Loading = false
      Store.SuccessResult = null
      throw e
    }
  }

  /**
   * 取消Http请求
   */
  const Cancel = () => {
    Store.Loading = false
    return DWHttp.Cancel()
  }
  return Object.assign(Store, { Execute, Cancel })
}
export default MobXHttp
